import { request } from "../../httpClient";

export const getVehiclesListRequest = async () => {
  const res = await request({
    path: "vehicle/list",
  });
  return res;
};
